/**
 * Returns current slide index after update.
 */
export const getCurrentSlideIndex = ({
  currentSlideIndex,
  slidesCount
}) => currentSlideIndex >= slidesCount ? 0 : currentSlideIndex;
//# sourceMappingURL=getCurrentSlideIndex.js.map